/*
 *
 * PersonalData Api
 *
 * @version 1.0.0
 * @author NEOSYN\user
 * @since 05-Nov-2024
 */

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
import appEnvRemap from 'Utility/appEnvRemap'
if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/personalData/personalData')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}
export async function changeFullName (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-full-name',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changeFullNameVerify (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-full-name/verify',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changeEmail (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-email',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changeEmailVerify (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/sca-double/profile/change-email/verify',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changePhone (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-phone',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changePhoneVerify (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-phone/verify',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function deleteProfile (params) {
  let data

  try {
    data = await axios({
      method: 'delete',
      url: '/services/merchant-service/profile/delete-profile',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function deleteProfileVerify (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/delete-profile/verify',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changeFullNameResendOtp (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/profile/change-full-name/resend-otp',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changeEmailResendOtp (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/profile/change-email/resend-otp',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changePhoneResendOtp (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/profile/change-phone/resend-otp',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function deleteProfileResendOtp (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/profile/delete-profile/resend-otp',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getProfileData (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/profile',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function updatePassword (params) {
  let response

  const data = {
    oldPassword: params.oldPassword,
    newPassword: params.newPassword
  }

  try {
    response = await axios({
      method: 'post',
      baseURL: appEnvRemap.API_REST_IAM,
      url: '/self-password-update',
      data: {
        ...data
      }
    })
    return handlingResponse(response)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function generateOtp (params) {
  let data

  const { user, serviceId, servicePayload, additionalInfo } = params

  try {
    data = await axios({
      method: 'post',
      baseURL: appEnvRemap.API_REST_IAM,
      url: '/mfa/generate-otp',
      data: { user, serviceId, servicePayload },
      headers: {
        additionalInfo
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function updateConsents (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/consents',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getConsents (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/profile/consents',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function updateFiscalCode (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-fiscalcode',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function checkISPCertificationData (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/check-isp-certification-data',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function validateIspData (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/validate-isp-data',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function checkChangeEmail (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/check/change-email',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changeEmailVerifyWithEmail (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-email/verify/email',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function changeEmailVerifyWithPhone (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-email/verify/sms',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function changeEmailDoubleVerify (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/sca-double/profile/change-email/verify',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function checkChangePhone (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/check/change-phone',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changePhoneDoubleVerify (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/sca-double/profile/change-phone/verify',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changePhoneVerifyWithPhone (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-phone/verify/sms',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function changePhoneVerifyWithEmail (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/profile/change-phone/verify/email',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
